var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"expense-details"},[_c('section',{staticClass:"details-section"},[_c('ExpenseDetailsBody',{attrs:{"expense":_vm.currentExpense}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }